var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M100 200C155.228 200 200 155.228 200 100C200 44.7715 155.228 0 100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.195 197.252C154.259 197.252 198.086 153.425 198.086 99.361C198.086 45.2973 154.259 1.46992 100.195 1.46992C46.1311 1.46992 2.30371 45.2973 2.30371 99.361C2.30371 153.425 46.1311 197.252 100.195 197.252Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.287 197.639C119.415 197.67 138.129 192.07 154.095 181.536C150.487 161.822 136.76 160.699 136.76 160.699H61.0576C61.0576 160.699 48.1035 161.762 44.0576 179.897C60.5187 191.476 80.1613 197.674 100.287 197.639Z",
    fill: "#2896F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2464 144.547C125.341 144.547 146.496 123.393 146.496 97.298C146.496 71.2029 125.341 50.0487 99.2464 50.0487C73.1513 50.0487 51.9971 71.2029 51.9971 97.298C51.9971 123.393 73.1513 144.547 99.2464 144.547Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M83.9971 136.653H114.272V160.874C114.272 164.888 112.678 168.737 109.841 171.576C107.003 174.414 103.154 176.01 99.1403 176.011C95.1256 176.011 91.2753 174.417 88.4365 171.578C85.5976 168.739 84.0028 164.889 84.0028 160.874V136.653H83.9971Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9571 135.53H113.324C113.578 135.53 113.823 135.631 114.003 135.811C114.183 135.991 114.284 136.235 114.284 136.49V159.751C114.284 161.739 113.893 163.709 113.132 165.546C112.371 167.383 111.255 169.052 109.849 170.458C108.443 171.864 106.773 172.98 104.936 173.74C103.098 174.501 101.129 174.892 99.1405 174.891C95.1257 174.891 91.2755 173.296 88.4366 170.457C85.5978 167.619 84.0029 163.768 84.0029 159.754V136.49C84.0029 136.236 84.1033 135.993 84.282 135.813C84.4608 135.633 84.7035 135.532 84.9571 135.53Z",
    fill: "#FDB797"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M84.0518 148.086C93.8091 151.731 104.55 151.761 114.327 148.169V144.444H84.0518V148.086Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2465 150.112C123.213 150.112 142.642 130.683 142.642 106.716C142.642 82.7497 123.213 63.3209 99.2465 63.3209C75.2799 63.3209 55.8511 82.7497 55.8511 106.716C55.8511 130.683 75.2799 150.112 99.2465 150.112Z",
    fill: "#FDB797"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.3354 67.2435C68.3354 67.2435 86.6248 104.367 138.215 82.808L126.204 63.9742L104.911 56.3324L68.3354 67.2435Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3354 66.6991C68.3354 66.6991 86.6248 103.822 138.215 82.2579L126.204 63.4241L104.911 55.7822L68.3354 66.6991Z",
    fill: "#333333"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M68.175 64.1834C69.4081 60.366 71.5395 56.9002 74.3899 54.0774C82.9257 45.639 96.92 43.8596 104.098 34.2378C105.817 36.9083 104.487 41.0143 101.519 42.1605C108.396 42.1146 116.364 41.5129 120.252 35.8567C121.213 38.0938 121.52 40.5576 121.136 42.9618C120.752 45.3661 119.693 47.6119 118.083 49.4384C124.178 49.7249 130.691 53.851 131.075 59.9398C131.338 63.9971 128.782 67.8367 125.462 70.1633C122.141 72.49 118.095 73.5587 114.126 74.4327C102.539 76.9914 60.6134 87.6991 68.175 64.1834Z",
    fill: "#333333"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8336 114.246C58.0633 114.246 59.8709 110.857 59.8709 106.676C59.8709 102.495 58.0633 99.106 55.8336 99.106C53.6039 99.106 51.7964 102.495 51.7964 106.676C51.7964 110.857 53.6039 114.246 55.8336 114.246Z",
    fill: "#FDB797"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.636 114.246C144.866 114.246 146.674 110.857 146.674 106.676C146.674 102.495 144.866 99.106 142.636 99.106C140.407 99.106 138.599 102.495 138.599 106.676C138.599 110.857 140.407 114.246 142.636 114.246Z",
    fill: "#FDB797"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 100,
    y1: 200,
    x2: 100,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.ae477171d62f8a1aadf558d3030e1067.svg";
export { ForwardRef as ReactComponent };